<template>
  <div class="col-12">
    <hr />
    <EditorGroupToggle
      label="Classroom Settings"
      target="toggleGroupClassroomSettings"
      class="mb-4"
      :collapsed="false"
    />
    <div id="toggleGroupClassroomSettings" class="collapse show row">
      <div class="col-12 mb-4">
        <div class="text-center w-100">
          <Field
            type="checkbox"
            name="is_virtual"
            id="cb_is_virtual"
            label="This is a VIRTUAL CLASSROOM course"
            v-model="isVirtual"
            :checkbox-value="1"
          />
        </div>
      </div>
      <div class="col-12 col-xl-6 mb-3">
        <EditEventTimes :value="course.times" />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="text"
          label="Minimum Attendees"
          name="min_attendees"
          :value="course.min_attendees"
        />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="text"
          label="Maximum Attendees"
          name="max_attendees"
          :value="course.max_attendees"
        />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="select"
          name="cost_type"
          label="Cost Type"
          :value="course.cost_type"
          :options="costTypes"
          :hideSelectEmptyOption="true"
        />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="text"
          name="cost"
          :label="`${costLabelPrefix} Standard Cost`"
          :value="course.cost"
          :readonly="managersOnly"
        />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="text"
          name="fad_cost"
          :label="`${costLabelPrefix} FAD/Elite Cost`"
          :value="course.fad_cost"
          :readonly="managersOnly"
        />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="text"
          name="distributor_cost"
          label="Distributor Employee Cost"
          :value="course.distributor_cost"
        />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="select"
          name="materials_fee_type"
          label="License/Materials Fee Type"
          :value="course.materials_fee_type"
          :options="invoiceTypes"
          :hideSelectEmptyOption="true"
        />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="text"
          name="materials_fee"
          label="Estimated License/Materials Fee"
          :value="course.materials_fee"
        />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="select"
          name="trainer_fee_type"
          label="Trainer Fee Type"
          :value="course.trainer_fee_type"
          :options="invoiceTypes"
          :hideSelectEmptyOption="true"
        />
      </div>
      <div class="col-12 col-xl-3 mb-3">
        <Field
          type="text"
          name="trainer_fee"
          label="Estimated Trainer Fee"
          :value="course.trainer_fee"
        />
      </div>
      <div class="col-12 mb-3">
        <MultiAssignField name="included_courses"
                          type="select"
                          label="Included Courses"
                          :options="courses"
                          :value="course._included_courses"/>
      </div>
      <div class="col-12 col-xl-6 mb-3 pt-3">
        <Field
          type="checkbox"
          name="distributor_billed"
          id="cb_distributor_billed"
          label="This course should be billed at the Distributor Flat Rate"
          v-model="distributorBilled"
          :checkbox-value="1"
        />
        <Field
          v-if="distributorBilled"
          class="mt-3"
          type="text"
          name="distributor_billing_fee"
          label="Distributor Billing Flat Fee"
          :value="course.distributor_billing_fee"
        />
      </div>
      <div class="col-12 col-xl-6 mb-3 pt-3">
        <Field
          v-if="!distributorBilled"
          type="checkbox"
          name="bill_before_event"
          id="cb_bill_before_event"
          label="Bill 50% of the minimum attendees cost on all events for this course"
          :value="!!course.bill_before_event"
          :checkbox-value="1"
        />
      </div>
      <div class="col-12 col-xl-6 mb-3 pt-3">
        <Field
          type="checkbox"
          name="trainer_travel_reimbursed"
          id="cb_trainer_travel_reimbursed"
          label="The trainer's travel fees are reimbursed"
          v-model="trainerTravelReimbursed"
          :checkbox-value="1"
        />
        <Field
          v-if="trainerTravelReimbursed"
          class="mt-3"
          type="text"
          name="trainer_travel_fee"
          label="Estimated Trainer Travel Fees"
          :value="course.trainer_travel_fee"
        />
      </div>
      <div class="col-12 col-xl-6 mb-3 pt-3">
        <Field
          type="checkbox"
          name="kit_needed"
          id="cb_kit_needed"
          label="Materials are needed for this course"
          v-model="materialsNeeded"
          :checkbox-value="1"
        />
      </div>
      <template v-if="ownerType == 'FACTORY'">
        <div class="col-12 col-xl-3 mb-3 pt-3">
          <Field
            type="checkbox"
            name="authorized_training"
            id="cb_authorized_training"
            label="This is an Authorized Training course"
            v-model="authorizedTraining"
            :checkbox-value="1"
          />
        </div>
        <div class="col-12 col-xl-3 mb-3">
          <Field
            v-if="authorizedTraining"
            type="text"
            name="meta[max_auth_training_cost]"
            label="Maximum Cost Billed"
            :value="course.max_auth_training_cost"
          />
        </div>
        <div class="col-12 col-xl-6 mb-3 pt-3">
          <Field
            v-if="authorizedTraining"
            type="checkbox"
            name="allow_dist_trainer"
            id="cb_allow_dist_trainer"
            label="Distributor Trainers in the Sponsor Distributorship may train events for this course"
            :value="!!course.allow_dist_trainer"
            :checkbox-value="1"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import EditEventTimes from "./EditEventTimes";
export default {
  components: { EditEventTimes },
  props: {
    course: { type: Object, required: true },
    courses: { type: Array, default: () => []},
    ownerType: { type: String },
    costTypes: { type: Array, required: true },
    invoiceTypes: { type: Array, required: true },
    managersOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      isVirtual: false,
      distributorBilled: false,
      trainerTravelReimbursed: false,
      materialsNeeded: false,
      authorizedTraining: false,
    };
  },
  computed: {
    costLabelPrefix() {
      return this.ownerType == "DISTRIBUTOR" ? "Distributor" : "Factory";
    },
  },
  mounted() {
    this.isVirtual = !!this.course.is_virtual;
    this.distributorBilled = !!this.course.distributor_billed;
    this.trainerTravelReimbursed = !!this.course.trainer_travel_reimbursed;
    this.materialsNeeded = !!this.course.kit_needed;
    this.authorizedTraining = !!this.course.authorized_training;
  },
};
</script>